import { Component, ElementRef, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AppService } from '../../app.service';
import { PaginationService } from '../../PaginationService';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { SuccessSnackbarComponent } from '../success-snackbar/success-snackbar.component';
import { messageService } from '../../message.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';
import { EditorComponent } from '../../editor/editor.component';
import { EditorConfig, ST_BUTTONS } from 'ngx-simple-text-editor';
import { DocumentViewerComponent } from '../document-viewer/document-viewer.component';
import { DocViewerConfig } from '../models/doc-viewer-config.model';

@Component({
  selector: 'app-trainings-conclusive-trail',
  templateUrl: './trainings-conclusive-trail.component.html',
  styleUrls: ['./trainings-conclusive-trail.component.scss']
})

export class TrainingsConclusiveTrailComponent {

  isProcessing: boolean = false;

  selectedTrailCriteria: string = '';
  searchPopupTitle: string = '';
  trainingNameSearch: string = '';
  trainingCodeSearch: string = '';
  userNameSearch: string = '';
  firstNameSearch: string = '';
  lastNameSearch: string = '';
  emailSearch: string = '';

  selectedTabIndex: number = 0;

  trailCriteria: any = [];
  tabs: any = [];
  trainings: any = [];
  users: any = [];
  draftTraining: any = {};
  draftUser: any = {};
  pickedTraining: any = {};
  pickedUser: any = [];

  dropdownForCategory: any = [];
  dropdownForLanguage: any = [];
  dropDownForDesignation: any = [];
  dropDownForDepartment: any = [];
  dropDownForTraining: any = [];

  categoryDropdown: any = [];
  languageDropdown: any = [];
  designationDropdown: any = [];
  departmentDropdown: any = [];
  trainingDropDown: any = [];

  selectedCategory: any = null;
  selectedLanguage: any = null;
  selectedDesignation: any = null;
  selectedDepartment: any = null;
  selectedTraining: any = null;

  trainingsSearchText: string = '';
  categorySearchText: string = '';
  languageSearchText: string = '';
  designationSearchText: string = '';
  departmentSearchText: string = '';
  columnSearchText: string = '';

  focusSearch(value: any) {
    setTimeout(() => {
      let searchBox = document.getElementById(value);
      searchBox?.focus();
    }, 0)
  }

  constructor(private appService: AppService, public dialog: MatDialog, public paginationService: PaginationService, private elem: ElementRef, public message: messageService, private snackBar: MatSnackBar, private router: Router) {
    this.message.breadcrumbData.thirdLevel = 'Conclusive Trail';
  }

  ngOnInit(): void {

    this.trailCriteria = ['Training Master', 'User Training']

    this.tabs = [{
      tab_icon: "fa-solid fa-book-open",
      tab_name: "Training Details"
    }, {
      tab_icon: "fa-solid fa-list",
      tab_name: "Contents"
    }, {
      tab_icon: "fa fa-file-text",
      tab_name: "Assessments"
    }, {
      tab_icon: "fa fa-pencil",
      tab_name: "Assessment Options"
    }]



    this.appService.getCategoriesList().subscribe((category: any) => {
      this.dropdownForCategory = category;
      this.selectBoxForCategory();
    })

    this.appService.getCodeListsByGroup("TRAINING_LANGUAGE").subscribe((language: any) => {
      this.dropdownForLanguage = language;
      this.selectBoxForLanguage();
    })

    const designation: any[] = JSON.parse(sessionStorage.getItem('dropDownForDesignationCode') ?? '[]');
    this.dropDownForDesignation = Array.isArray(designation) ? [...designation].sort((m: { codelistName: string }, n: { codelistName: string }) => m.codelistName.trim().localeCompare(n.codelistName.trim())) : [];
    this.selectBoxForDesignation();

    const department: any[] = JSON.parse(sessionStorage.getItem('dropDownForDepartmentCode') ?? '[]');
    this.dropDownForDepartment = Array.isArray(department) ? [...department].sort((m: { codelistName: string }, n: { codelistName: string }) => m.codelistName.trim().localeCompare(n.codelistName.trim())) : [];
    this.selectBoxForDepartment();
  }

  onTabChanged(event: any) { this.execute(); }

  onCriteriaChange() { this.primaryReset(); }

  primaryReset() {
    if (this.selectedTrailCriteria === 'Training Master') {
      [this.trainings, this.pickedTraining] = [[], {}];
    } else {
      [this.users, this.pickedUser, this.dropDownForTraining, this.trainingDropDown, this.selectedTraining] = [[], {}, [], [], null];
    }
  }

  goBack() {
    this.message.breadcrumbData.thirdLevel = ''; this.router.navigate(['/dashboard/tmsReport'])
  }

  @ViewChild('searchTraining', { static: true }) searchTraining: TemplateRef<any>;
  visibleSearchTrainingPopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('searchUser', { static: true }) searchUser: TemplateRef<any>;
  visibleSearchUserPopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('pdfViewerPopup', { static: true }) pdfViewerPopup: TemplateRef<any>;
  visiblePdfViewerPopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('imageViewerPopup', { static: true }) imageViewerPopup: TemplateRef<any>;
  visibleImageViewerPopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('viewer', { static: false }) viewer: ElementRef;
  @ViewChild(EditorComponent) editorComponent!: EditorComponent;


  searchConfig = {
    width: '100%',
    height: 'auto',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };

  pdfViewerConfig = {
    width: '80%',
    height: '80%',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  }

  selectBoxForCategory() {
    this.categoryDropdown = this.dropdownForCategory?.map((category: any) => ({
      valueExp: category.trainingCategoryCode,
      displayExp: category.trainingCategoryName
    }))?.sort((m: { displayExp: string }, n: { displayExp: string }) => m.displayExp?.trim()?.localeCompare(n.displayExp?.trim())) || []
  }

  selectBoxForLanguage() {
    this.languageDropdown = this.dropdownForLanguage?.map((category: any) => ({
      valueExp: category.codelistCode,
      displayExp: category.codelistName
    }))?.sort((m: { displayExp: string }, n: { displayExp: string }) => m.displayExp?.trim()?.localeCompare(n.displayExp?.trim())) || []
  }

  selectBoxForDepartment() {
    this.departmentDropdown = this.dropDownForDepartment?.map((item: any) => ({
      valueExp: item.codelistCode,
      displayExp: item.codelistName
    }))?.sort((m: { displayExp: string }, n: { displayExp: string }) => m.displayExp?.trim()?.localeCompare(n.displayExp?.trim())) || []
  }

  selectBoxForDesignation() {
    this.designationDropdown = this.dropDownForDesignation?.map((item: any) => ({
      valueExp: item.codelistCode,
      displayExp: item.codelistName
    }))?.sort((m: { displayExp: string }, n: { displayExp: string }) => m.displayExp?.trim()?.localeCompare(n.displayExp?.trim())) || []
  }

  selectBoxForTraining() {
    this.trainingDropDown = this.dropDownForTraining?.map((item: any) => ({
      valueExp: item.trainingId,
      displayExp: item.trainingName
    }))?.sort((m: { displayExp: string }, n: { displayExp: string }) => m.displayExp?.trim()?.localeCompare(n.displayExp?.trim())) || []
  }

  selectedTrainingName: string = '';
  onTrainingSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (item) {
        setTimeout(() => {
          this.execute();
          this.selectedTrainingName = item.displayExp;
        })
      } else {
        this.selectedTrainingName = "";
      }
    }
  }

  onTrainingSelectOld() { this.execute(); }

  onTrainingDeSelect() { }

  onNgModelChange(items: any, fieldId: string) {
    const field = document.getElementById(fieldId) as HTMLInputElement;
    field.style.color = items ? '#005c8a' : 'red';
  }

  openSearchPopup(searchFor: string) {
    if (searchFor == 'Training(s)') {
      [this.trainingNameSearch, this.trainingCodeSearch, this.selectedCategory, this.selectedLanguage, this.trainings, this.draftTraining] = ['', '', null, null, [], {}]
      this.searchPopupTitle = 'Search ' + searchFor
      this.visibleSearchTrainingPopup = this.dialog.open(this.searchTraining, this.searchConfig)
    } else {
      [this.userNameSearch, this.firstNameSearch, this.lastNameSearch, this.emailSearch, this.selectedDepartment, this.selectedDesignation, this.users, this.draftUser] = ['', '', '', '', null, null, [], {}]
      this.searchPopupTitle = 'Search ' + searchFor
      this.visibleSearchUserPopup = this.dialog.open(this.searchUser, this.searchConfig)
    }
  }

  closeSearchPopup(searchingFor: string) {
    if (searchingFor == 'Training(s)') this.visibleSearchTrainingPopup.close(); else this.visibleSearchUserPopup.close();
  }

  searchTrainings() {
    this.isProcessing = true;

    const obj = {
      trainingName: this.trainingNameSearch,
      trainingCode: this.trainingCodeSearch,
      category: this.selectedCategory ?? null,
      language: this.selectedLanguage ?? null,
      groupId: null
    };

    this.appService.searchTrainingsByCondition(obj).subscribe((response: any) => {
      this.trainings = response.sort((m: { trainingName: string; }, n: { trainingName: string; }) => m.trainingName.trim().localeCompare(n.trainingName.trim()));
      this.isProcessing = false;
    })
  }

  searchUsers() {
    this.isProcessing = true;

    const obj = {
      userName: this.userNameSearch ? this.userNameSearch.toUpperCase() : '',
      firstName: this.firstNameSearch,
      lastName: this.lastNameSearch,
      emailAddress: this.emailSearch,
      designationCode: this.selectedDesignation ?? null,
      departmentCode: this.selectedDepartment ?? null,
    };

    this.appService.searchUsersForInstructorTraining(obj).subscribe((response: any) => {
      this.users = response.sort((m: { userName: string; }, n: { userName: string; }) => m.userName.trim().localeCompare(n.userName.trim()));
      this.isProcessing = false;
    })
  }

  onChildChecked(e: any, data: any) {
    if (this.selectedTrailCriteria == 'Training Master') {
      this.trainings.every((item: any) => { if (item.trainingChildCheckBox) { item.trainingChildCheckBox = false; } return true; })

      if (e.target.checked) {
        data.trainingChildCheckBox = true;
        this.draftTraining = data;
      } else {
        data.trainingChildCheckBox = false;
        this.draftTraining = {};
      }
    } else {
      this.users.every((item: any) => { if (item.userChildCheckBox) { item.userChildCheckBox = false; } return true; })

      if (e.target.checked) {
        data.userChildCheckBox = true;
        this.draftUser = data;
      } else {
        data.userChildCheckBox = false;
        this.draftUser = {};
      }
    }
  }

  pick() {
    if (this.selectedTrailCriteria == 'Training Master') {
      this.pickedTraining = this.draftTraining;
      this.visibleSearchTrainingPopup.close();
      this.execute();
    } else {
      this.pickedUser = this.draftUser;
      this.visibleSearchUserPopup.close();
      this.isProcessing = true;
      this.appService.getTrainingsByUserId(this.pickedUser.userId).subscribe((training: any) => {
        this.dropDownForTraining = training?.filter((item: any, index: number, self: any) => index === self.findIndex((t: any) => (t.trainingId === item.trainingId)));
        this.selectBoxForTraining();
        this.isProcessing = false;
      });

    }
  }

  reset() {
    if (this.selectedTrailCriteria == 'Training Master') [this.trainingNameSearch, this.trainingCodeSearch, this.selectedCategory, this.selectedLanguage, this.trainings] = ['', '', null, null, []]
    else[this.userNameSearch, this.firstNameSearch, this.lastNameSearch, this.emailSearch, this.selectedDepartment, this.selectedDesignation, this.users] = ['', '', '', '', null, null, []]
  }

  execute() {
    const index = this.selectedTabIndex;

    if (this.selectedTrailCriteria == 'Training Master') {
      if (index == 0) {
        this.trail.tableOrView_Name = "TMS_TRAININGS_AU_VW";
        this.trail.columnList_DB = "CREATED_TS,END_TS,ACTION_FLAG,TRAINING_CODE,TRAINING_NAME,CATEGORY_CODE,LANGUAGE,VERSION,IS_LATEST_VERSION,IS_LATEST_PUBLISHED_VERSION,STATUS,DESCRIPTION,TOTAL_DURATION,SELF_ASSIGNABLE,EXPIRY_DATE,EXPIRY_IN_DAYS,TRAINING_IMAGE,TRAINING_IMAGE_EXTN,INTIMATE_EXPIRY_BEFORE_IN_DAYS,CREATED_ON,CREATED_BY_USER,UPDATED_ON,UPDATED_BY_USER,UPDATE_REASON";
        this.trail.columnList_UI = "Created Timestamp,End Timestamp,Action Flag,Training Code,Training Name,Category,Language,Version,Is Latest Version,Is Latest Published Version,Status,Description,Total Duration,Self Assignable,Expiry Date,Expiry in Days,Training Image,Training Image Extension,Intimate Expiry Before In Days,Created On,Created By,Updated On,Updated By,Update Reason";
        this.trail.whereClause_AU = " AND TRAINING_ID=" + this.pickedTraining.trainingId + " AND VERSION=" + this.pickedTraining.version;
        this.trail.columnList_Report = "Created Timestamp,End Timestamp,Action Flag,Training Code,Training Name,Category,Language,Version,Is Latest Version,Is Latest Published Version,Status,Description,Total Duration,Self Assignable,Expiry Date,Expiry in Days,Training Image,Training Image Extension,Intimate Expiry Before In Days,Created On,Created By,Updated On,Updated By,Update Reason";
        this.trail.whereClause_Report = " WHERE TRAINING_ID=" + this.pickedTraining.trainingId + " AND VERSION=" + this.pickedTraining.version;
        this.trail.report_And_Popup_Name = 'Training Details Audit Trail [' + this.pickedTraining.trainingName + ' V-' + this.pickedTraining.version + ']';
        this.populateTrail();
      } else if (index == 1) {
        this.trail.tableOrView_Name = "TMS_TRAINING_CONTENTS_AU_VW";
        this.trail.columnList_DB = "CREATED_TS,END_TS,ACTION_FLAG,CONTENT_NAME,DOCUMENT_NAME,DOCUMENT_VERSION,NO_OF_QUESTIONS_FOR_ASSESSMENT,TOTAL_DURATION,PASS_PERCENTAGE,WAIT_TIME_IN_MINS,CONTENT_DESCRIPTION,CONTENT_EXTN,CONTENT_FILE,CONTENT_SEQ,FOLDER_PATH,IS_QUESTION_CONTENT,DOCUMENT_NO,VERSION,CREATED_ON,CREATED_BY_USER,UPDATED_ON,UPDATED_BY_USER,DELETED_BY_USER,DELETED_REASON";
        this.trail.columnList_UI = "Created Timestamp,End Timestamp,Action,Content Name,Document Name,Document Version,No Of Questions For Assessment,Total Duration,Pass Percentage,Wait Time In Mins,Content Description,Content Extension,Content File,Content Seq,Folder Path,Is Question Content,Document No,Version,Created On,Created By,Updated On,Updated By,Deleted By,Deleted Reason";
        this.trail.whereClause_AU = " AND TRAINING_ID = " + this.pickedTraining.trainingId;
        this.trail.columnList_Report = "Created Timestamp,End Timestamp,Action,Content Name,Document Name,Document Version,No Of Questions For Assessment,Total Duration,Pass Percentage,Wait Time In Mins,Content Description,Content Extension,Content File,Content Seq,Folder Path,Is Question Content,Document No,Version,Created On,Created By,Updated On,Updated By,Deleted By,Deleted Reason";
        this.trail.whereClause_Report = " WHERE TRAINING_ID = " + this.pickedTraining.trainingId;
        this.trail.report_And_Popup_Name = 'Training Content Audit Trail [' + this.pickedTraining.trainingName + ']';
        this.populateTrail();
      } else if (index == 2) {
        this.trail.tableOrView_Name = "TMS_TRAINING_QUESTIONS_AU_VW";
        this.trail.columnList_DB = "CREATED_TS,END_TS,ACTION_FLAG,SEQ,QUESTION,QUESTION_TYPE,QUESTION_IMAGE,QUESTION_IMAGE_EXTN,ANSWER,VERSION,CREATED_ON,CREATED_BY_USER,UPDATED_ON,UPDATED_BY_USER,DELETED_BY_USER,DELETED_REASON";
        this.trail.columnList_UI = "Created Timestamp,End Timestamp,Action Flag,Seq,Question,Question Type,Question Image,Question Image Extension,Answer,Version,Created On,Created By,Updated On,Updated By,Deleted By,Deleted Reason";
        this.trail.whereClause_AU = " AND TRAINING_ID=" + this.pickedTraining.trainingId;
        this.trail.columnList_Report = "Created Timestamp,End Timestamp,Action Flag,Seq,Question,Question Type,Question Image,Question Image Extension,Answer,Version,Created On,Created By,Updated On,Updated By,Deleted By,Deleted Reason";
        this.trail.whereClause_Report = " WHERE TRAINING_ID=" + this.pickedTraining.trainingId;
        this.trail.report_And_Popup_Name = 'Training Questions Audit Trail [' + this.pickedTraining.trainingName + ']';
        this.populateTrail();
      } else {
        this.trail.tableOrView_Name = "TMS_TRAINING_QUESTION_OPTIONS_AU_VW";
        this.trail.columnList_DB = "CREATED_TS,END_TS,ACTION_FLAG,OPTION_CODE,OPTION_IMAGE,OPTION_IMAGE_EXTN,OPTION_VALUE,VERSION,CREATED_ON,CREATED_BY_USER,UPDATED_ON,UPDATED_BY_USER,DELETED_BY_USER,DELETED_REASON";
        this.trail.columnList_UI = "Created Timestamp,End Timestamp,Action Flag,Option Code,Option Image,Option Image Extension,Option Value,Version,Created On,Created By,Updated On,Updated By,Deleted By,Deleted Reason";
        this.trail.whereClause_AU = " AND TRAINING_ID=" + this.pickedTraining.trainingId;
        this.trail.columnList_Report = "Created Timestamp,End Timestamp,Action Flag,Option Code,Option Image,Option Image Extension,Option Value,Version,Created On,Created By,Updated On,Updated By,Deleted By,Deleted Reason";
        this.trail.whereClause_Report = " WHERE TRAINING_ID=" + this.pickedTraining.trainingId;
        this.trail.report_And_Popup_Name = 'Training Options Audit Trail [' + this.pickedTraining.trainingName + ']';
        this.populateTrail();
      }
    } else {
      this.trail.tableOrView_Name = "TMS_USER_TRAININGS_REP_AU_VW";
      this.trail.columnList_DB =
        'CREATED_TS,END_TS,ACTION_FLAG,USER_NAME,USR_FULLNAME,TRAINING_NAME,TRAINING_CODE,VERSION,TYPE,TOTAL_DURATION,CATEGORY_CODE,COMMENTS,LANGUAGE,USER_TRAINING_STATUS,TRAINING_LEVEL,TRAINER_NAME,TRAINING_ASSIGNED_ON,IS_USER_ACTIVE,IS_USER_AT_GROUP_ACTIVE,IS_GROUP_ACTIVE,IS_TRAINING_AT_GROUP_ACTIVE,IS_LATEST_VERSION,IS_LATEST_PUBLISHED_VERSION,ALLOWED_FAILED_ATTEMPTS,ALLOWED_FAILED_ATTEMPTS_AFTER_UNLOCK,LIST_OF_QA_USERS_NAME,LOCKED_ON,MANAGER_USERNAME,MANAGER_FULLNAME,GROUP_NAME,MARKED_AS_COMPLETED_BY_USER,MAX_ALLOWED_FAILED_ATTEMPTS,MAX_FAILED_ATTEMPT_REACHED,NO_OF_FAILED_UNLOCK,NO_OF_OVERDUE_UNLOCK,OVERDUE_LOCK_QA_APPROVED_ON,OVERDUE_LOCK_RM_APPROVED_ON,OVERDUE_QA_APPROVAL_REQD,OVERDUE_RM_APPROVAL_REQD,NO_OF_TIMES_COMPLETED,RELAUNCH_REASON,RETAKE_AFTER_N_MIN_ON_FAILED_ATTEMPT,REPEAT_TRAINING,REPEAT_INTERVAL,REPEAT_INTERVAL_UNIT,SHOW_ANSWERS_AT_REVIEW,ALLOW_TO_REVIEW_RESULTS,DUE_N_DAY_FROM_ASSIGNED,DUE_N_DAY_FROM_OVERDUE_UNLOCK,ESCALATION_SENT_ON,ESCALATE_EVERY_N_DAYS,EMAIL_ADDRESS,ESCALATE,REMINDER_SENT_ON,REMIND_EVERY_N_DAYS,REMIND_N_DAY_BEFORE_DUE,FAILED_ATTEMPTS,FAILED_ATTEMPTS_AFTER_UNLOCK,FAILED_ATTEMPT_REACHED,FAILED_LOCK_RM_APPROVED_ON,FAILED_ON,SCHEDULED_TRAINING_ASSESSMENT,SCHEDULED_TRAINING_STATUS,INTIMATION_SCHEDULED,INTIMATION_SENT_ON,STARTED_ON,START_DATE,END_DATE,ESIGNATURE_DONE,FINAL_SCORE,EXPIRY_DATE,COMPLETED_ON';
      this.trail.columnList_UI = "Created Ts,End Ts,Action Flag,User Name,User Fullname,Training Name,Training Code,Version,Type,Total Duration,Category Code,Comments,Language,User Training Status,Training Level,Trainer Name,Training Assigned On,Is User Active,Is User At Group Active,Is Group Active,Is Training At Group Active,Is Latest Version,Is Latest Published Version,Allowed Failed Attempts,Allowed Failed Attempts After Unlock,List Of Qa Users,Locked On,Manager Username,Manager Fullname,Group Name,Marked As Completed By,Max Allowed Failed Attempts,Max Failed Attempt Reached,No Of Failed Unlock,No Of Overdue Unlock,Overdue Lock Qa Approved On,Overdue Lock Rm Approved On,Overdue Qa Approval Reqd,Overdue Rm Approval Reqd,No Of Times Completed,Relaunch Reason,Retake After N Min On Failed Attempt,Repeat Training,Repeat Interval,Repeat Interval Unit,Show Answers At Review,Allow To Review Results,Due N Day From Assigned,Due N Day From Overdue Unlock,Escalation Sent On,Escalate Every N Days,Email Address,Escalate,Reminder Sent On,Remind Every N Days,Remind N Day Before Due,Failed Attempts,Failed Attempts After Unlock,Failed Attempt Reached,Failed Lock Rm Approved On,Failed On,Scheduled Training Assessment,Scheduled Training Status,Intimation Scheduled,Intimation Sent On,Started On,Start Date,End Date,Esignature Done,Final Score,Expiry Date,Completed On";
      this.trail.whereClause_AU = " AND TRAINING_ID=" + this.selectedTraining + " AND USER_ID = " + this.pickedUser.userId;
      this.trail.columnList_Report = "Created Ts,End Ts,Action Flag,User Name,User Fullname,Training Name,Training Code,Version,Type,Total Duration,Category Code,Comments,Language,User Training Status,Training Level,Trainer Name,Training Assigned On,Is User Active,Is User At Group Active,Is Group Active,Is Training At Group Active,Is Latest Version,Is Latest Published Version,Allowed Failed Attempts,Allowed Failed Attempts After Unlock,List Of Qa Users,Locked On,Manager Username,Manager Fullname,Group Name,Marked As Completed By,Max Allowed Failed Attempts,Max Failed Attempt Reached,No Of Failed Unlock,No Of Overdue Unlock,Overdue Lock Qa Approved On,Overdue Lock Rm Approved On,Overdue Qa Approval Reqd,Overdue Rm Approval Reqd,No Of Times Completed,Relaunch Reason,Retake After N Min On Failed Attempt,Repeat Training,Repeat Interval,Repeat Interval Unit,Show Answers At Review,Allow To Review Results,Due N Day From Assigned,Due N Day From Overdue Unlock,Escalation Sent On,Escalate Every N Days,Email Address,Escalate,Reminder Sent On,Remind Every N Days,Remind N Day Before Due,Failed Attempts,Failed Attempts After Unlock,Failed Attempt Reached,Failed Lock Rm Approved On,Failed On,Scheduled Training Assessment,Scheduled Training Status,Intimation Scheduled,Intimation Sent On,Started On,Start Date,End Date,Esignature Done,Final Score,Expiry Date,Completed On";
      this.trail.whereClause_Report = " WHERE TRAINING_ID=" + this.selectedTraining + " AND USER_ID = " + this.pickedUser.userId;
      this.trail.report_And_Popup_Name = 'Training Options Audit Trail [' + this.selectedTrainingName + ']';
      this.populateTrail();
    }
  }

  noData: boolean = false;
  pager: any = {};
  itemsPerPage = 5;
  currentPage = 1;
  totalPages = 0;
  maxSize = 3;
  collectionSize: number;
  perPage = 10;
  calculateTotalPages: number;
  showingResultsText = "Showing results";
  displayingClaimsText = "Displaying claims";
  rowText = "Rows";
  showingRowsText = "Showing rows";
  searchValue: any;
  whereClause: any;
  columnListAuditTrails: any;
  columnListAuditTrails1: any;
  fiveColumnForAuditTrails: any;
  spColumnForAuditTrails: any;
  fiveFieldLabelsColumnForAuditTrails: any;
  spFieldLabelsColumnForAuditTrails: any;
  tableOrViewNameForAuditTrails: any;
  columnListsAuditTrails: any = {};
  dataTypeList: any = [];
  grid: any = [];
  makeStickyColumns: any;
  pagedItems: any[];
  selectedColumns: any = [];
  columnList: any;
  dropDownForPdfColumn: any;
  isForExcel: boolean = false;
  statusCodeValue: any;
  htmlContent: any;
  extension1: any;
  reportObj: any = {};
  reportPopupTitle: string = '';
  trail: any = {};

  populateTrail() {
    this.isProcessing = true;
    this.tableOrViewNameForAuditTrails = this.trail.tableOrView_Name;
    this.columnListAuditTrails1 = this.trail.columnList_DB;
    this.spColumnForAuditTrails = "";
    this.spFieldLabelsColumnForAuditTrails = "";
    this.whereClause = this.trail.whereClause_AU;
    this.columnList = this.trail.columnList_Report;
    this.columnListAuditTrails = this.trail.columnList_UI;
    this.makeStickyColumns = "";

    const primary_obj: any = {

      gridName: null,
      tableOrViewName: this.tableOrViewNameForAuditTrails,
      columnsList: this.columnListAuditTrails1 + this.spColumnForAuditTrails,
      fieldLabelsList: this.trail.columnList_UI + this.spFieldLabelsColumnForAuditTrails,
      invisibleColumn: "",
      orderByClause: "CREATED_TS DESC",
      fieldSizeList: "",
      columnsListarray: [],
      fieldColumnarray: [],
      invisibleColumnarray: [],
      fieldSizeListArray: [],
      status: this.statusCodeValue,
      codelistGroup: null,
      manualEntryDataFields: null,
      groupId: null,
      chartStatus: "",
      whereClause: this.whereClause
    }

    this.appService.staticGridAuditTrailsData(primary_obj).subscribe({
      next: (response1: any) => {
        this.grid = response1;
        this.noData = response1.length;
        primary_obj.columnsListarray = primary_obj.columnsList.split(",");
        primary_obj.fieldColumnarray = primary_obj.fieldLabelsList.split(",");
        primary_obj.fieldSizeListArray = primary_obj.fieldSizeList.split(",");

        this.columnListsAuditTrails.columnsListarray = primary_obj.columnsListarray;
        this.columnListsAuditTrails.fieldLabelsList = primary_obj.fieldLabelsList;
        this.columnListsAuditTrails.fieldColumnarray = [];

        for (let p = 0; p < primary_obj.fieldColumnarray.length; p++) {
          this.columnListsAuditTrails.fieldColumnarray.push({
            "fieldColumnarray": primary_obj.fieldColumnarray[p],
            "width": primary_obj.fieldSizeListArray[p] + 'px'
          })
        }

        this.columnListsAuditTrails.fieldSizeListArray = [];
        for (const element of primary_obj.fieldSizeListArray) {
          this.columnListsAuditTrails.fieldSizeListArray.push(element + 'px');
        }

        let tableData = {
          tablename: primary_obj.tableOrViewName
        };
        this.columnListsAuditTrails.columnsListarray1 = [];
        this.appService.tableFieldsDataType(tableData).subscribe((response2: any) => {
          this.dataTypeList = response2;
          for (let m = 0; m < this.columnListsAuditTrails.columnsListarray.length; m++) {
            this.columnListsAuditTrails.columnsListarray1.push({});
            this.columnListsAuditTrails.columnsListarray1[m].columnsListarray = this.columnListsAuditTrails.columnsListarray[m];
            this.columnListsAuditTrails.columnsListarray1[m].dataType = "textbox";
            this.columnListsAuditTrails.columnsListarray1[m].width = this.columnListsAuditTrails.fieldSizeListArray;

            for (const element of this.dataTypeList) {
              if (element.columnName == this.columnListsAuditTrails.columnsListarray[m]) {
                this.columnListsAuditTrails.columnsListarray1[m].dataType = element.fieldType;
              }
            }
          }

          for (const rowData of this.grid) {
            for (const element of this.dataTypeList) {
              if (element.fieldType === 'CHECKBOX') {
                rowData[element.columnName] = rowData[element.columnName] === 'Y';
              }
            }
          }

          this.calculateTotalPages = this.collectionSize / this.perPage;
          this.pager.totalPages = undefined;
          this.setPage(1, 0);
          this.isProcessing = false;
        });
        this.collectionSize = this.grid.length;
      },
      error: (error) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }

  pagination(value: number) {
    this.perPage = value;
    this.setPage(this.pager.currentPage, 0);
  }

  setPage(page: number, targetPage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }

    this.pager = this.paginationService.getPager(this.grid.length, page, this.perPage, targetPage);
    this.pagedItems = this.grid?.slice(this.pager.startIndex, this.pager.endIndex + 1);
  }

  applyFilter3(column: string, event: Event): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.pagedItems = this.grid.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = this.grid.filter((item: any) =>
        item[column]?.toLowerCase().includes(filter)
      );
    }
  }

  counts: any;
  css(ix: number) {
    let elements1 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-col1');
    let index1 = 1;
    let headerWidth = 0;
    elements1.forEach((header: any, key: any) => {
      for (let i = 1; i <= this.makeStickyColumns; i++) {
        if (index1 == i) {
          header.style.position = 'sticky';
          header.style.background = 'white';
          if (index1 > 1) {
            headerWidth += 200;
            header.style.left = headerWidth + 'px';
          } else {
            headerWidth = 60;
            header.style.left = headerWidth + 'px';
          }
        }
      }
      index1++;
    })

    let elements2 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-row1');
    let index2 = 1;
    let lengthOfColumns = this.columnListsAuditTrails.columnsListarray1.length;
    let colWidth = 0;
    elements2.forEach((column: any, key: any) => {
      for (let j = 1; j <= this.makeStickyColumns; j++) {
        if (index2 == j) {
          column.style.position = 'sticky';
          column.style.background = 'white';
          column.style.textDecoration = "underline";
          column.style.color = "blue";
          column.style.cursor = "pointer";
          if (index2 > 1) {
            colWidth += 200;
            let previousColumn = elements2[key - 1];
            console.log(previousColumn.style.width);
            column.style.left = colWidth + 'px';
          } else {
            colWidth = 60;
            column.style.left = colWidth + 'px';
          }
        }
      }
      if (index2 == (lengthOfColumns - 1)) {
        index2 = 0;
      } else {
        index2++;
      }
    })
  }

  @ViewChild('excelPdfPopup', { static: true }) excelPdfPopup: TemplateRef<any>;
  visibleExcelPdfPopup: MatDialogRef<TemplateRef<any>>;

  excelPdfPopupConfig = {
    width: '750px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  }

  openReportPopup(item: any) {
    this.pdfPageSizes = JSON.parse(sessionStorage.getItem('pdfPageSizes') ?? '{}');
    this.pdfPageSize = 'A4';
    this.dropDownForPdfColumn = this.columnList?.split(',')?.filter((item: any) => item != 'Content File')?.map((column: any) => ({ valueExp: column, displayExp: column }));
    this.isForExcel = item == 'Excel';
    this.reportPopupTitle = item == 'Excel' ? 'Excel Report' : 'PDF Report';
    [this.manuallyPicked, this.maxCountReached, this.selectedColumns] = [false, false, []];
    this.visibleExcelPdfPopup = this.dialog.open(this.excelPdfPopup, this.excelPdfPopupConfig);
  }

  cancelReportPopup() {
    this.visibleExcelPdfPopup.close();
    [this.manuallyPicked, this.maxCountReached, this.selectedColumns] = [false, false, []];
  }

  manuallyPicked: boolean;
  pdfPageSizes: any = [];
  pdfPageSize: string = "";
  onCheckboxChange(event: MatSlideToggleChange) {
    if (!event.checked) {
      [this.manuallyPicked, this.maxCountReached, this.selectedColumns] = [false, false, []];
    }
  }

  maxCountReached: boolean = false;
  selectedColumnsAsString: string = "";
  @ViewChild('columns') columns: MatSelect;
  isAllColumns = false;

  toggleAllSelection(value: any) {
    if (value == 'columns') {
      if (this.isAllColumns) this.columns.options.forEach((item: MatOption) => item.select());
      else {
        this.columns.options.forEach((item: MatOption) => item.deselect())
        this.selectedColumns = [];
      }
      setTimeout(() => {
        if (this.selectedColumns.length > 10) this.maxCountReached = true; else this.maxCountReached = false;
        this.convertArrayToString(this.selectedColumns);
      });
    }
  }

  onColumnSelect(event: any, item: any) {
    if (event.isUserInput) {
      setTimeout(() => {
        if (this.selectedColumns.length > 10) this.maxCountReached = true; else this.maxCountReached = false;
        this.convertArrayToString(this.selectedColumns);
        this.isAllColumns = this.selectedColumns.length == this.dropDownForPdfColumn.length;
      });
    }
  }

  onSelect() {
    if (this.selectedColumns.length > 10) this.maxCountReached = true; else this.maxCountReached = false;
    this.convertArrayToString(this.selectedColumns);
  }

  onDeSelect() {
    this.onSelect();
  }

  onSelectAll(item: any[]) {
    if (item.length > 10) this.maxCountReached = true; else this.maxCountReached = false;
    this.convertArrayToString(item);
  }

  onDeSelectAll(item: any[]) {
    if (item.length > 10) this.maxCountReached = true; else this.maxCountReached = false;
    this.convertArrayToString(item);
  }

  convertArrayToString(array: any) {
    this.selectedColumnsAsString = array.join(', ');
  }

  @ViewChild(DocumentViewerComponent) documentViewerComponent!: DocumentViewerComponent;
  docViewer!: DocViewerConfig;
  imageViewerTitle: string = '';
  downloadDocuments(list: any, columnName: any) {
    this.isProcessing = true;
    let docObj = {
      primeIdentifier: list.PRIM_IDENTIFIER,
      tableView: list.tablevwname,
      columnName: columnName
    }

    this.appService.getDocumentToViewAudit(docObj).subscribe((data: any) => {

      const header = data.headers.get('content-type');
      this.extension1 = null;
      let dbExtension = list.CONTENT_EXTN || list.contentExtn || list.content_extn;

      if (dbExtension) {
        this.extension1 = dbExtension.toLowerCase().replace('.', '');
      }

      if (!this.extension1) {
        if (header && (header.includes('image/png') || header.includes('image/x-png'))) {
          this.extension1 = 'png';
        } else if (header && header.includes('pdf')) {
          this.extension1 = 'pdf';
        } else if (header && header.includes('text/plain')) {
          this.extension1 = 'txt';
        } else if (header && header.includes('wordprocessingml')) {
          this.extension1 = 'docx';
        } else if (header && header.includes('spreadsheetml')) {
          this.extension1 = 'xlsx';
        } else if (header && header.includes('presentationml')) {
          this.extension1 = 'pptx';
        } else if (header && header.includes('image/jpeg')) {
          this.extension1 = 'jpg';
        }
      }

      if (['jpg', 'jpeg', 'png', 'gif', 'bmp'].includes(this.extension1)) {

        this.imageViewerTitle = list.CONTENT_NAME;

        this.visibleImageViewerPopup = this.dialog.open(this.imageViewerPopup, this.searchConfig);

        let blob = new Blob([data.body], { type: header || "image/png" });
        let url = URL.createObjectURL(blob);

        setTimeout(() => {
          let imageElement: any = document.getElementById("picturewe");
          if (imageElement) {
            imageElement.src = url;
          }
          this.isProcessing = false;
        }, 100);

      }
      else {

        let finalContentType = header;
        if (!finalContentType || finalContentType === 'application/octet-stream') {
          if (this.extension1 === 'pptx') finalContentType = 'application/vnd.openxmlformats-officedocument.presentationml.presentation';
          else if (this.extension1 === 'pdf') finalContentType = 'application/pdf';
          else if (this.extension1 === 'docx') finalContentType = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
        }

        const blob = new Blob([data.body], { type: finalContentType });

        const doc = {
          body: data.body,
          contentType: finalContentType,
          extn: this.extension1
        }

        this.docViewer = {
          blob: blob,
          doc: doc,
          docName: list.CONTENT_NAME,
          docExtension: this.extension1,
          isFromOnlyPreview: true
        };

        this.isProcessing = false;

        setTimeout(() => {
          this.documentViewerComponent?.openPopUp();
        });
      }
    }, (error) => {
      this.isProcessing = false;
      console.error(error);
      this.showSnackBar('Failed to download document', 'E');
    })
  }
  cancelPdfViewer() {
    this.visiblePdfViewerPopup.close();
  }

  cancelImageViewer() {
    this.visiblePdfViewerPopup?.close();

    this.visibleImageViewerPopup?.close();
  }

  getClobData(list: any, columnName: any) {
    this.isProcessing = true;
    let docObj = {

      primeIdentifier: list.PRIM_IDENTIFIER,
      tableView: list.tablevwname,
      columnName: columnName
    }
    this.htmlContent = "";
    this.appService.getClobToViewAudit(docObj).subscribe({
      next: (Response: any) => {
        this.htmlContent = Response.result;
        this.editorComponent.openEditor(this.htmlContent, columnName);
      }, error: (error) => {
        this.isProcessing = false;
        throw error;
      }
    });
    this.isProcessing = false;
  }

  generateReport(value: any) {
    if (value == 'Pdf' && this.manuallyPicked && !this.selectedColumns.length) {
      this.showSnackBar('Please select the Columns', 'E');
    } else {
      const primary_obj = {

        groupId: null
      }

      let $DB = this.columnListAuditTrails1.split(',');

      const columnsToRemoveFrom_DB = ['DOC', 'TEMPLATE', 'CONTENT_EXTN', 'QUESTION_IMAGE', 'OPTION_IMAGE', 'CONTENT_FILE'];

      columnsToRemoveFrom_DB.forEach(column => {
        let index = $DB.indexOf(column);
        if (index !== -1) {
          $DB.splice(index, 1);
        }
      });
      this.columnListAuditTrails1 = $DB.join(',');

      console.log('DB', this.columnListAuditTrails1);

      let $UI = this.trail.columnList_UI.split(',');

      const columnsToRemoveFrom_Report = ['Document', 'Template', 'Content Extension', 'Question Image', 'Option Image', 'Content File'];

      columnsToRemoveFrom_Report.forEach(column => {
        let index = $UI.indexOf(column);
        if (index !== -1) {
          $UI.splice(index, 1);
        }
      });
      this.trail.columnList_UI = $UI.join(',');

      console.log('UI', this.trail.columnList_UI);

      const secondary_obj: any = {

        tableOrViewName: this.tableOrViewNameForAuditTrails,
        columnsList: this.columnListAuditTrails1,
        fieldLabelsList: this.trail.columnList_UI,
        invisibleColumn: "",
        orderByClause: "CREATED_TS DESC",
        fieldSizeList: "",
        columnsListarray: [],
        fieldColumnarray: [],
        invisibleColumnarray: [],
        fieldSizeListArray: [],
        status: this.statusCodeValue,
        codelistGroup: null,
        manualEntryDataFields: null,
        groupId: null,
        chartStatus: null,
        wherVal: this.trail.whereClause_Report,
        reModule: "tms"
      }

      this.reportObj = { ...primary_obj, ...secondary_obj };

      const timestamp = Date.now();
      const formattedDate = new Intl.DateTimeFormat('en-US', {
        day: '2-digit', month: 'short', year: 'numeric',
      }).format(new Date(timestamp)).replace(/[, ]/g, (match) => match === ',' ? '' : '_');

      const extension = value == 'Excel' ? 'xlsx' : 'pdf';

      if (value == 'Excel') {
        const excel_data = {
          ...this.reportObj, title: this.trail.report_And_Popup_Name, columns: [],
          "informationTab": { "Report Name": this.trail.report_And_Popup_Name, "Exported By": localStorage.getItem("loggedUserName") }
        }

        this.downloadReport(excel_data, `${this.trail.report_And_Popup_Name.replaceAll(" ", "_")}_${formattedDate}.${extension}`, 'excel');
      } else {
        const pdf_data = {
          ...this.reportObj, title: this.trail.report_And_Popup_Name, columns: this.manuallyPicked ? this.selectedColumns.join(',') : this.columnList.split(',').slice(0, 10).join(','), pdfPageSize: this.pdfPageSize, logoId: 0, isSaveRep: 'N'
        }

        this.downloadReport(pdf_data, `${this.trail.report_And_Popup_Name.replaceAll(" ", "_")}_${formattedDate}.${extension}`, 'pdf');
      }
    }
  }

  downloadReport(data: any, fileName: string, downloadAs: string) {
    if (downloadAs == 'excel') {
      this.isProcessing = true;
      this.appService.downloadExcel(data).subscribe({
        next: (fileResponse: any) => {
          let dataType = fileResponse.type;
          let binaryData = [];
          binaryData.push(fileResponse);
          let downloadLink = document.createElement('a');
          downloadLink.href = window.URL.createObjectURL(new Blob(binaryData, { type: dataType }));
          if (fileName)
            downloadLink.setAttribute('download', fileName);
          document.body.appendChild(downloadLink);
          downloadLink.click();
          this.isProcessing = false;
        },
        error: (error) => {
          this.isProcessing = false;
          throw error;
        }
      })
    } else {
      this.isProcessing = true;
      this.appService.downloadPdfFile(data).subscribe({
        next: (fileResponse: any) => {
          let dataType = fileResponse.type;
          let binaryData = [];
          binaryData.push(fileResponse);
          let downloadLink = document.createElement('a');
          downloadLink.href = window.URL.createObjectURL(new Blob(binaryData, { type: dataType }));
          if (fileName)
            downloadLink.setAttribute('download', fileName);
          document.body.appendChild(downloadLink);
          downloadLink.click();
          this.isProcessing = false;
        },
        error: (error) => {
          this.isProcessing = false;
          throw error;
        }
      })
    }
  }


  wvInstance: any;
  showUploadDiv: boolean = false;
  isShowToUploadDiffFile: boolean = false;
  loadDataInViewer(data: any, extn: any) {
    this.showUploadDiv = true;


    if (this.wvInstance != undefined && this.wvInstance.UI && false) {

    } else {
      WebViewer({
        path: '../../../wv-resources/lib',
        licenseKey: 'Clinevo Technologies Private Limited (clinevotech.com):OEM:eTrials::B+:AMS(20231004):FEA5C54D0427360AF360B13AC982737B60610F8BAF461E35E56C05DA5C956EAE0AFAB6F5C7', // sign up to get a key at https://dev.apryse.com
        fullAPI: true,
        //  webViewerServer : true,
        disabledElements: [
          'leftPanelButton',
          'toolbarGroup-Annotate',
          'highlightToolGroupButton',
          'underlineToolGroupButton',
          'strikeoutToolGroupButton',
          'squigglyToolGroupButton',
          'freeTextToolGroupButton',
          'shapeToolGroupButton',
          'stickyToolGroupButton',
          'freeHandToolGroupButton',
          'toolsOverlay',
          'eraserToolButton',
          'redoButton',
          'stickyToolButton',
          'textPopup',
          'toggleNotesButton',
          'selectToolButton',
          'highlightToolButton',
          'freeHandToolButton',
          'freeTextToolButton',
          'toolsHeader',
          'printButton',

        ]
      }, this.viewer.nativeElement).then((instance: any) => {
        this.wvInstance = instance;

        instance.UI.disableElements(['printButton']);
        instance.UI.disableFeatures([instance.UI.Feature.Print]);

        // Also block Ctrl+P inside viewer (built-in PDFTron shortcut)
        instance.UI.addEventListener(instance.UI.Events.KEY_DOWN, (e: KeyboardEvent) => {
          instance.UI.addEventListener(instance.UI.Events.KEY_DOWN, (e: KeyboardEvent) => {
            if (e.ctrlKey && e.key.toLowerCase() === 'p') {
              e.preventDefault();
              e.stopPropagation();
              alert('Printing is disabled.');
            } else {
              e.preventDefault();
              e.stopPropagation();
            }
            return false;
          });
        });
        instance.UI.setTheme('dark');
        instance.print = false;
        instance.UI.disableElements(['toolbarGroup-Shapes']);
        instance.UI.disableElements(['toolbarGroup-Edit']);
        instance.UI.disableElements(['toolbarGroup-Insert']);
        instance.UI.disableElements(['menuButton']);
        instance.UI.disableElements(['undoButton']);
        instance.UI.disableElements(['highlightToolGroupButton']);

        if (!extn) {
          instance.UI.loadDocument(data.body, { extension: extn });
        }

        const { documentViewer } = instance.Core;
        documentViewer.addEventListener('documentLoaded', () => {
          console.log("doc loaded");
        });

        const UIEvents = instance.UI.Events;
        instance.UI.addEventListener(UIEvents.LOAD_ERROR, function (err: any) {
          console.log(err);
        });

        instance.Core.documentViewer.addEventListener('documentLoaded')
      })
    }
  }

  showSnackBar(message: string, type: string) {
    const sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      duration: type === 'S' ? 5000 : undefined,
      data: {
        message,
        type: type === 'S' ? 'Success' : 'Error',
        buttonLabel: 'Ok',
        pageName: this.message.breadcrumbData.thirdLevel ?? this.message.breadcrumbData.secondLevel,
      },
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: type === 'S' ? 'Success' : 'Error',
    });

    sb.onAction().subscribe(() => {
      sb.dismiss();
    });
  }

  @ViewChild('angularEditor', { static: true }) angularEditor: TemplateRef<any>;
  visibleAngularEditor: MatDialogRef<TemplateRef<any>>;

  angularEditorConfig = {
    width: '100%',
    height: 'auto',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };

  caseConversion(format: string, value: any) {

    if (format == 'typical') {
      return value.split('_').map((word: string) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ')
    } else {
      return value.split('_').map((word: string, index: number) => index == 0 ? word.toUpperCase() : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ')
    }
  }

  editorTitle: string = '';
  editorNgModel: string = '';
  staticClobView(title: string, value: string) {
    this.editorTitle = this.caseConversion('atypical', title);
    this.editorNgModel = value;
    this.visibleAngularEditor = this.dialog.open(this.angularEditor, this.angularEditorConfig);
  }

  disabled: EditorConfig = {
    buttons: [],
  };

  enabled: EditorConfig = {
    buttons: ST_BUTTONS,
  };

  cancelAngularEditor() {
    this.visibleAngularEditor.close();
  }

}
